/* Copyright Verge Technologies 2018
 * @file requestCareer.modal.js
 * @author Brenton Watt <brenton@verge.co.za>
 */

// Modules
import axios from "axios";
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import Modal from 'react-modal';
import validator from 'validator';
import { Mutation } from 'react-apollo';
import _ from 'lodash';
import PropTypes from 'prop-types';

// GraphQL
import { CAREER_REQUEST } from '../../graphql';

const toBase64 = file => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
});

Modal.setAppElement(document.getElementById('root'));
class RequestCareerModal extends Component {
  //const [file, setFile] = useState(null);
  constructor(props) {
    super(props);
    this.state = {
      form: {
        firstName: '',
        lastName: '',
        email: '',
        contactNumber: '',
        category: 'career',
        enquiry: '',
        file: '',
        companyName:'N/A',
        companyLocation:'N/A',        
      },
      errors: {
        firstNameError: false,
        lastNameError: false,
        emailError: false,
        contactNumberError: false,
        categoryError: false,
        fileError: false,
      },
      // Initially, no file is selected
      selectedFile: null,
    };
  }


  

  // On file select (from the pop up)
  onFileChange = (event) => {
    const selectedFile = event.target.files[0];
    const self = this;
    toBase64(selectedFile).then( (result) =>{
      const updatedForm = { ...self.state.form };
      updatedForm["file"] = result;
      self.setState({
        ...self.state,
        form: updatedForm,
      });
    })

      // Update the state
      // this.setState({
      //     file: toBase64(selectedFile)
      // });
  };



  // On file select (from the pop up)
  onFileChangeAxios = (event) => {
      const selectedFile = event.target.files[0];

      // Update the state
      this.setState({
          selectedFile: event.target.files[0],
      });
  //};


  // On file upload (click the upload button)
  //onFileUpload = () => {
      // Create an object of formData
      const formData = new FormData();

      // Update the formData object
      formData.append(
          "myFile",
          selectedFile,
          selectedFile.name
      );

      // Details of the uploaded file
      console.log(selectedFile);

      // Request made to the backend api
      // Send formData object
      axios.post("api/uploadfile", formData);
  };

  changeHandler = (e) => {
    const updatedForm = { ...this.state.form };
    updatedForm[e.target.name] = e.target.value;
    this.setState({
      ...this.state,
      form: updatedForm,
    });
  };
  setFile = () => {

  };
  checkFields = () => {
    const {
      firstName,
      lastName,
      email,
      contactNumber,
      category,
      file,
    } = this.state.form;

    console.log("checkfields");
    console.log(this.state.form);
    // Check that a first name has been entered
    if (firstName === null || _.isUndefined(firstName) || firstName.length < 1) {
      this.setState({
        ...this.state,
        errors: {
          ...this.state.errors,
          firstNameError: true,
        },
      });
      return false;
    }

    // Check that a valid last name has been entered
    if (lastName === null || _.isUndefined(lastName) || lastName.length < 1) {
      this.setState({
        ...this.state,
        errors: {
          ...this.state.errors,
          lastNameError: true,
        },
      });
      return false;
    }

    // Check for valid email
    if (!validator.isEmail(email)) {
      this.setState({
        ...this.state,
        errors: {
          ...this.state.errors,
          emailError: true,
        },
      });
      return false;
    }

    // Check for valid contactNumber
    if (!validator.isMobilePhone(contactNumber)) {
      this.setState({
        ...this.state,
        errors: {
          ...this.state.errors,
          contactNumberError: true,
        },
      });
      return false;
    }


    // Check for valid contactNumber
    if (file === null || _.isUndefined(file) || file.length < 1) {
      this.setState({
        ...this.state,
        errors: {
          ...this.state.errors,
          fileError: true,
        },
      });
      return false;
    }

    // Check that company location passed is valid
    if (category === null || _.isUndefined(category) || category.length < 1) {
      this.setState({
        ...this.state,
        errors: {
          ...this.state.errors,
          categoryError: true,
        },
      });
      return false;
    }

    return true;
  };

  handleSubmit = (e, mutation) => {
    e.preventDefault();
    if (!this.checkFields()) {
      console.log("fail");
      return;
    }
    console.log("mutate");

    mutation();
    this.setState({
      form: {
        firstName: '',
        lastName: '',
        email: '',
        contactNumber: '',
        category: 'career',
        enquiry: '',
        file:'',
        companyName:'N/A',
        companyLocation:'N/A',

      },
      errors: {
        firstNameError: false,
        lastNameError: false,
        emailError: false,
        contactNumberError: false,
        fileError: false,
        categoryError: false,
      },
    });
    this.props.openThankYouModal();
  };

  render() {
    return (
      <Mutation
        mutation={CAREER_REQUEST}
        variables={{
          params: this.state.form,
        }}
      >
        {(postMutation) => {
          return (
            <Modal
              isOpen={this.props.isOpen}
              className="modal-background"
              overlayClassName="modal-overlay"
            >
              <div className="modal-background">
                <div className="modal">
                  <div className="inner">
                    <a onClick={this.props.closeModal} className="close">
                      <svg width="13px" height="13px" viewBox="0 0 13 13">
                        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                          <g
                            transform="translate(-1.000000, -1.000000)"
                            fill="#B1CEF0"
                            fillRule="nonzero"
                          >
                            <polygon
                              transform="translate(7.135000, 7.036000) rotate(180.000000) translate(-7.135000, -7.036000) "
                              points="7.234 8.294 7.134 8.194 2.254 13.073 0.996 11.815 5.776 7.037 0.996 2.257 2.254 0.999 7.034 5.779 7.134 5.879 12.014 0.999 13.271 2.256 8.496 7.036 13.274 11.816 12.017 13.073"
                            />
                          </g>
                        </g>
                      </svg>
                    </a>
                    <h4>Career Application</h4>
                    <div className="form">
                      <div className="row">
                        <input
                          type="text"
                          name="firstName"
                          placeholder="First name"
                          value={this.state.form.firstName}
                          onChange={e => this.changeHandler(e)}
                        />
                        {
                          this.state.errors.firstNameError ? <label className="error">Please add a first name!</label> : ''
                        }
                      </div>
                      <div className="row">
                        <input
                          type="text"
                          name="lastName"
                          placeholder="Last name"
                          value={this.state.form.lastName}
                          onChange={e => this.changeHandler(e)}
                        />
                        {
                          this.state.errors.lastNameError ? <label className="error">Please add a last name!</label> : ''
                        }
                      </div>

                      <div className="row">
                        <input
                          type="email"
                          name="email"
                          placeholder="Email address"
                          value={this.state.form.email}
                          onChange={e => this.changeHandler(e)}
                        />
                        {
                          this.state.errors.emailError ? <label className="error">Please add a valid email address!</label> : ''
                        }
                      </div>
                      <div className="row">
                        <input
                          type="text"
                          name="contactNumber"
                          placeholder="Contact number"
                          value={this.state.form.contactNumber}
                          onChange={e => this.changeHandler(e)}
                        />
                        {
                          this.state.errors.contactNumberError ? <label className="error">Please add a valid contact number!</label> : ''
                        }
                      </div>


                      <div className="row">
                        <textarea
                          name="enquiry"
                          placeholder="Applying for..."
                          value={this.state.enquiry}
                          onChange={e => this.changeHandler(e)}
                        />
                      </div>

                      <div className="row">
                      <a href="#" onClick={ e => document.querySelector("[name='file']").click() } className="button button-line" style={{position:"absolute"}}>Upload your CV</a>

                      <input name="file" type="file" onChange={this.onFileChange} style={{marginLeft: "35px",position: "0",marginBottom: "15px",marginTop: "5px"}}/>
                        {
                          this.state.errors.fileError ? <label className="error">Please updload your CV</label> : ''
                        }                      
                      </div>

                      <div className="control">
                        <a
                          onClick={e => this.handleSubmit(e, postMutation)}
                          className="button button-green"
                        >
                          Submit
                        </a>
                        <a onClick={this.props.closeModal} className="button button-line">
                          Cancel
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Modal>
          );
        }}
      </Mutation>
    );
  }
}

RequestCareerModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
};


export default withRouter(RequestCareerModal);



// WEBPACK FOOTER //
// ./src/components/RequestCareerModal/requestCareerModal.js